import React from "react";

interface LocalizedNumberProps {
  value: string | number;
}

// Renders a number through a read-only <input type="number"> so its decimal
// separator is localized by the exact same browser mechanism as the editable
// value fields. This guarantees displayed values mirror the input on every
// machine — including when the OS Region and the browser language disagree,
// which Intl/toLocaleString cannot detect. Falls back to plain text if the
// value isn't numeric.
const LocalizedNumber: React.FC<LocalizedNumberProps> = ({ value }) => {
  const numeric = Number(String(value).replace(",", "."));
  if (Number.isNaN(numeric)) {
    return <>{String(value)}</>;
  }
  const canonical = String(numeric);
  return (
    <input
      type="number"
      value={canonical}
      readOnly
      tabIndex={-1}
      aria-hidden="true"
      style={{
        border: "none",
        outline: "none",
        background: "transparent",
        padding: 0,
        margin: 0,
        font: "inherit",
        color: "inherit",
        textAlign: "right" as "right",
        display: "inline-block",
        verticalAlign: "baseline",
        width: `${canonical.length}ch`,
        pointerEvents: "none",
        MozAppearance: "textfield" as "textfield",
      }}
    />
  );
};

export default LocalizedNumber;
